import instance from './common';

export const getAnnotations = (reqBody, options = {}, http = instance) => http.get('/annotations', reqBody, options);

export const getAnnotation = (reqBody, options = {}, http = instance) => http.get('/annotation', reqBody, options);

export const createAnnotation = (reqBody, options = {}, http = instance) => http.post('/annotation', reqBody, options);

export const updateAnnotation = (reqBody, options = {}, http = instance) => http.put('/annotation', reqBody, options);

export const deleteAnnotation = (annotationId, options = {}, http = instance) => http.delete(`/annotation/${annotationId}`, {}, options);

export const saveComment = (reqBody, options = {}, http = instance) => http.post('/annotation/comment', reqBody, options);

export const deleteComment = (annotationId, commentId, options = {}, http = instance) => http.delete(`/annotation/${annotationId}/comment/${commentId}`, {}, options);

